<template>
  <div
    ref="root"
    class="tooltip-layer">
    <transition-group
      tag="div"
      name="transition--opacity">
      <tooltip-layer-balloon
        v-for="tooltip in tooltips"
        v-show="tooltip.isVisible"
        :key="tooltip.token"
        :tooltip="tooltip"
        :layer="$refs.root"
        :style="`z-index: ${tooltip.zIndex}`"
        :class="[`tooltip__balloon--${tooltip.token}`, { [`tooltip-balloon--${tooltip.type}`]: tooltip.type }]"
        class="tooltip__balloon" />
    </transition-group>
  </div>
</template>

<script>
import TooltipLayerBalloon from './TooltipLayerBalloon.vue';

export default {
  name: 'TooltipRoot',

  components: {
    TooltipLayerBalloon,
  },

  computed: {
    tooltips() {
      return this.$store.state.tooltip.tooltipList;
    },
  },
};
</script>

<style scoped>
  .tooltip-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }

  .tooltip__balloon {
    pointer-events: auto;
  }
</style>
